import { render, staticRenderFns } from "./AssignSpecialist.vue?vue&type=template&id=43d58d93&scoped=true"
import script from "./AssignSpecialist.vue?vue&type=script&lang=js"
export * from "./AssignSpecialist.vue?vue&type=script&lang=js"
import style0 from "./AssignSpecialist.vue?vue&type=style&index=0&id=43d58d93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d58d93",
  null
  
)

export default component.exports